import $ from 'jquery';
window.$ = $;
import 'jquery-ui/dist/jquery-ui.min.js';
import './costum.scss';

//import 'bootstrap/scss/styles.scss';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {transform, fromLonLat, toLonLat} from 'ol/proj';
//import Stamen from 'ol/source/Stamen.js';
import Draw from 'ol/interaction/Draw.js';
import Overlay from 'ol/Overlay.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon, Text} from 'ol/style.js';
import {LineString, Polygon, Point} from 'ol/geom.js';
import { Vector as VectorSource} from 'ol/source.js';
import { Vector as VectorLayer} from 'ol/layer.js';
import {getArea, getLength} from 'ol/sphere.js';
import Feature from 'ol/Feature.js';
import {Control, OverviewMap, ScaleLine, FullScreen, ZoomSlider,  defaults as defaultControls} from 'ol/control.js';
import XYZ from 'ol/source/XYZ.js';
import {toStringHDMS} from 'ol/coordinate.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import * as bootstrap from 'bootstrap';

import {Maps} from './maps.js';
import {Bookmarks} from './booksmarks.js';
import {testData} from './test.js';
import {i18n} from './i18n.js';




const WD_HUMAN = "Q5";
const WD_MISSION = "Q20746389";
const WD_ENTERPRISE = "Q4830453";
const WD_AUTHORITY = "Q327333";
const WD_MILITARY = "Q45295908";
const WD_SETTLEMENT = "Q486972";
const WD_EVENT = "Q15815670";
const WD_COLONY = "Q133156";
const WD_GEOGRAFICAL = "Q618123";
const WD_SUBJECT = "Q82550";
const WD_EDUCATION = "Q2385804";

let wdClasses = {
  "Q5":"Human" ,
  "Q20746389":"Mission",
  "Q4830453":"Enterprise"  ,
  "Q327333":"Authority",
  "Q45295908":"Military",
  "Q486972":"Settlement" ,
  "Q15815670":"Event" ,
  "Q133156": "Colony" ,
  "Q618123":"Geografical" ,
  "Q82550":"Subject" ,
  "Q2385804":"Education" ,
};

let historicalMaps = new Maps();



/// Define the POI control

class POIControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.id = 'butPOI';
    button.value = 'false';
    button.innerHTML = '<i class="fa fa-location-pin"> </i>';
    button.title = "Points of Interest"
    const element = document.createElement('div');
    element.className = 'measure ol-unselectable ol-control position-absolute top-50 start-0 ms-2 mt-5';
    //element.className = 'measure ol-unselectable ol-control end-100 top-50';
    element.appendChild(button);
    

    super({
      element: element,
      //target:  'measurementTarget'

    });

    button.addEventListener('click', this.handlePOI.bind(this), false);
  }

  handlePOI() {
   
    if ($('#butPOI').val() == 'false' ){
      $('#butPOI').val("true");
      $('#butPOI').html('<i class="fa fa-location-dot"> </i>');
      poiVector.setVisible(true);
    }
    else {
      $('#butPOI').val("false");
      $('#butPOI').html('<i class="fa fa-location-pin"> </i>');
      poiVector.setVisible(false);
    }
    
    
  }
}




/// Define the measure control

class MeasureControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.id = 'butMeasurement';
    button.value = 'off';
    button.innerHTML = '<i class="fa fa-compass-drafting"> </i>';
    button.title = "Measurement off"
    const element = document.createElement('div');
    element.className = 'measure ol-unselectable ol-control position-absolute top-50 end-0 me-2 ';
    //element.className = 'measure ol-unselectable ol-control end-100 top-50';
    element.appendChild(button);
    

    super({
      element: element,
      //target:  'measurementTarget'

    });

    button.addEventListener('click', this.handleMeasure.bind(this), false);
  }

  handleMeasure() {
   
    if ($('#butMeasurement').val() == 'off' ){
      $('#butMeasurement').html('<i class="fa fa-ruler"> </i>');
      $('#butMeasurement').val('length');
      
    }
    else if ($('#butMeasurement').val() == 'length' ){
      $('#butMeasurement').html('<i class="fa fa-ruler-combined"> </i>');
      $('#butMeasurement').val('area');
      
    }
    else if ($('#butMeasurement').val() == 'area' ){
      $('#butMeasurement').html('<i class="fa fa-compass-drafting"> </i>');
      $('#butMeasurement').val('off');
      $('#butMeasurement').attr("title", "Measurement off")
      helpTooltipElement.classList.add('hidden');
    }
    renewInteraction();
  }
}

  class LayerControl extends Control {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
      const options = opt_options || {};
  
      const button = document.createElement('button');
      button.id = 'butLayer';
      button.value = 'osm';
      button.innerHTML = '<i class="fa fa-mound"></i>';
      button.title = "Select background layer"
      const element = document.createElement('div');
      element.className = 'measure ol-unselectable ol-control position-absolute top-0 end-0 me-2 mt-5';
      //element.className = 'layer ol-unselectable ol-control ';
      element.appendChild(button);
      
      super({
        element: element,
        //target: 'layerTarget'
      });
  //target: options.target,
      button.addEventListener('click', this.handleLayer.bind(this), false);
    }

  handleLayer() {
   
    if ($('#butLayer').val() == 'osm' ){
      $('#butLayer').val('open_topo') ;
      $('#butLayer').html('<i class="fa-solid fa-grip-lines"> </i>');
      raster.setSource(openTopoSource);
      
    }
    else {
      $('#butLayer').val('osm') ;
      $('#butLayer').html('<i class="fa fa-mound"> </i>');
      raster.setSource(osmSource);
    }
      
  }
}

class TransparencyControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const input = document.createElement('input');
    input.type = 'range';
    input.min = '0' ;
    input.max ='100';
    input.value = "100";
    input.title = "Transparency";
    const element = document.createElement('div');
    element.className = 'measure ol-unselectable ol-control position-absolute bottom-0 start-50 mb-2 ms-2';
    //element.className = 'ol-unselectable ol-control';
    element.appendChild(input);
    
    super({
      element: element,
      //target: 'transparencyTarget'
    });
//target: options.target,
    input.addEventListener('click', this.handleTransparency.bind(this), false);
  }

  handleTransparency() {
    historicLayer.setOpacity(Number(this.element.children[0].value)/100);
  }
}

// fill searchForDocuments handler

function addSearchForDocumentsHandler(){
  console.log(jQuery('#search-box-input').val());
  let e = $('#searchForDocuments').on('click',function(){
    if (jQuery('#search-box-input').attr("term") != "") {
      document.location.href = "https://archivfuehrer-kolonialzeit.de?query=" + jQuery('#search-box-input').attr("term").toLowerCase();
    }
  })
}



let bookmarks = new Bookmarks();
/// fill bookmark handler

function addBookmarksHandler(){
  for (let i = 0; i < bookmarks.length; i++) {
    //let e = document.getElementById("kol-"+ i);
    let e = $("#kol-"+ i).on('click',i, function(el){
      map.getView().setZoom(parseInt(bookmarks.getZoom(i)));
      map.getView().setCenter(fromLonLat([parseFloat(bookmarks.getLon(i)), parseFloat(bookmarks.getLat(i))]));  
    })
  }
}

addBookmarksHandler();

function addLanguageHandler(){
  const availableLanguages = ["en","fr","de"];
  for ( let i = 0; i < availableLanguages.length; i++){
    let e = $("#lang-"+ availableLanguages[i]).on('click',i, function(el){
      window.location.href += "/" + availableLanguages[i];
      location.reload();
    });
  }
}


// define the search-for-documents control


addLanguageHandler();



const historicLayer= new TileLayer({
  source: new OSM({
    opaque: false,
    url: 'data/tiles/{z}/{x}/{-y}.png',
    attributions: ""
  }),
});

//     url: 'data/tiles/{z}/{x}/{-y}.png',

const openTopoSource = new XYZ({
  url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
  attributions: " © OpenStreetMap-Mitwirkende, SRTM | Kartendarstellung: © OpenTopoMap (CC-BY-SA)"
});

const raster = new TileLayer({
  source: new OSM(),
});

const poiSource = new VectorSource({
  format: new GeoJSON(),
  projection: "EPSG:3857",
  url: 'tmp/features.geojson'
});

const poiVector = new VectorLayer({
  source: poiSource,
  style: StyleFunction,
  visible: false
});

let markerVector = new VectorLayer({
    visible: true,
    zIndex: 101
})

const source = new VectorSource();

const vector = new VectorLayer({
  source: source,
  style: {
    'fill-color': 'rgba(255, 255, 255, 0.2)',
    'stroke-color': '#ffcc33',
    'stroke-width': 2,
    'circle-radius': 7,
    'circle-fill-color': '#ffcc33',
  },
});

/**
 * Currently drawn feature.
 * @type {import("../src/ol/Feature.js").default}
 */
let sketch;

/**
 * The help tooltip element.
 * @type {HTMLElement}
 */
let helpTooltipElement;

/**
 * Overlay to show the help messages.
 * @type {Overlay}
 */
let helpTooltip;

/**
 * The measure tooltip element.
 * @type {HTMLElement}
 */
let measureTooltipElement;

/**
 * Overlay to show the measurement.
 * @type {Overlay}
 */
let measureTooltip;

/**
 * Message to show when the user is drawing a polygon.
 * @type {string}
 */
const continuePolygonMsg = 'Click to continue drawing the polygon';

/**
 * Message to show when the user is drawing a line.
 * @type {string}
 */
const continueLineMsg = 'Click to continue drawing the line';

/**
 * Message to show when the user is drawing a polygon.
 * @type {string}
 */
const continueNoMsg = '';

/**
 * Handle pointer move.
 * @param {import("../src/ol/MapBrowserEvent").default} evt The event.
 */
const pointerMoveHandler = function (evt) {
  const coordinate = evt.coordinate;
  const hdms = toStringHDMS(toLonLat(coordinate));
  if (evt.dragging) {
    return;
  }

  /** @type {string} */
  let helpMsg = hdms;

  if (sketch) {
    const geom = sketch.getGeometry();
    if (geom instanceof Polygon) {
      helpMsg = continuePolygonMsg;
    } else if (geom instanceof LineString) {
      helpMsg = continueLineMsg;
    }
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltip.setPosition(evt.coordinate);

  helpTooltipElement.classList.add('hidden');
};

let control

const osmSource = new OSM();

const overviewMapControl = new OverviewMap({
  layers: [
    new TileLayer({
      source: osmSource,
    }),
  ],
});

function scaleControl() {
  control = new ScaleLine({
      units: "metric",
  });
  control.element.className = 'measure ol-unselectable ol-control position-absolute bottom-0 end-50  mb-2 me-5  '
  return control;
}

function fullScreenControl(){
  control = new FullScreen();
  control.source = 'fullscreen';
  return control;
}


const map = new Map({
  controls: defaultControls().extend([
    new MeasureControl(),
    new LayerControl(),
    new POIControl(),
    overviewMapControl,
    scaleControl(),
    new ZoomSlider(),
    fullScreenControl(),
    new TransparencyControl(),
  ]), 
  target: 'map',
  layers: [
    raster, 
    historicLayer,
    poiVector,
    vector,
    markerVector
  ],
  view: new View({
    center: [0, 0],
    zoom: 2,
    maxZoom: 16,
    minZoom: 3
  })
});


//////////////////////


createHelpTooltip();

map.getViewport().addEventListener('mouseout', function () {
  helpTooltipElement.classList.add('hidden');
});

//const typeSelect2 = document.getElementById('type');
const typeSelect = $('#butmeasurement');

let draw; // global so we can remove it later

/**
 * Format length output.
 * @param {LineString} line The line.
 * @return {string} The formatted length.
 */
const formatLength = function (line) {
  const length = getLength(line);
  let output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

/**
 * Format area output.
 * @param {Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
const formatArea = function (polygon) {
  const area = getArea(polygon);
  let output;
  if (area > 10000) {
    output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
  } else {
    output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
  }
  return output;
};

function addInteraction() {
  
  const type = $('#butMeasurement').val() == 'area' ? 'Polygon' : 'LineString';
  //const type = $('typeSelect').attr('state') == 'area' ? 'Polygon' : 'LineString';
  draw = new Draw({
    source: source,
    type: type,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  map.addInteraction(draw);


  createMeasureTooltip();
  


  let listener;
  draw.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
    let tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      const geom = evt.target;
      let output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
      }
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  draw.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip();
    unByKey(listener);
  });
}

/**
 * Creates a new help tooltip
 */
function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  map.addOverlay(helpTooltip);
}

/**
 * Creates a new measure tooltip
 */
function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
    stopEvent: false,
    insertFirst: false,
  });
  map.addOverlay(measureTooltip);

}

/**
 * Let user change the geometry type.
 */
typeSelect.onchange = function () {
  map.removeInteraction(draw);
  if ($('#butMeasurement').val() != "off") {
     addInteraction();
  }
 
};

function renewInteraction (){
  map.removeInteraction(draw);
  helpTooltipElement.innerHTML = continueNoMsg;
  helpTooltipElement.classList.add('hidden');

  if ($('#butMeasurement').val() != "off") {
    addInteraction();

  }
  //map.removeOverlay(measureTooltip);
};

// start measuring if enabled
if ($('#butMeasurement').val() != "off") {
  addInteraction();
}


//////////////////// Permanent link

if (window.location.hash !== '') {
  // try to restore center, zoom-level and rotation from the URL
  const hash = window.location.hash.replace('#map=', '');
  const parts = hash.split('/');
  if (parts.length >= 4) {
    let zoom = parseFloat(parts[0]);
    let center = [parseFloat(parts[1]), parseFloat(parts[2])];
    let rotation = parseFloat(parts[3]);
  }
}

let shouldUpdate = true;
const view = map.getView();
const mapMoveendFunction = function () {

  //Update permalink

  if (!shouldUpdate) {
    // do not update the URL when the view was changed in the 'popstate' handler
    shouldUpdate = true;
    return;
  }

  const center = view.getCenter();
  const hash =
    '#map=' +
    view.getZoom().toFixed(2) +
    '/' +
    center[0].toFixed(2) +
    '/' +
    center[1].toFixed(2) +
    '/' +
    view.getRotation();
  const state = {
    zoom: view.getZoom(),
    center: view.getCenter(),
    rotation: view.getRotation(),
  };
  window.history.pushState(state, 'map', hash);




  // Update map attribution

  let coord =  transform(map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
  let zoom = map.getView().getZoom();
  const currentHistMap = historicalMaps.getMapByCoord(coord,zoom);
  //const currentHistMap = getCurrentHistMap(coord, zoom);
  //$("#current-map").html("<strong >"+i18n(74)+"</strong>");
  $("#current-map").html(createMapAttribution(currentHistMap));
  

};

///

map.on('pointermove', pointerMoveHandler);
map.on('moveend', mapMoveendFunction);




// restore the view state when navigating through the history, see
// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
window.addEventListener('popstate', function (event) {
  if (event.state === null) {
    return;
  }
  map.getView().setCenter(event.state.center);
  map.getView().setZoom(event.state.zoom);
  map.getView().setRotation(event.state.rotation);
  shouldUpdate = false;
});

/*
function getCurrentHistMap(coord, zoom) {
  var best = 0;
  var lat = coord[1];
  var lon = coord[0];
  for (var i = 1; i < MAPS.length; i++) {
    if (MAPS[i]["zoomLevel"] != "") {
      if (MAPS[i]["xMaximum"] > lon && MAPS[i]["xMinimum"] < lon && MAPS[i]["yMaximum"] > lat && MAPS[i]["yMinimum"] < lat && MAPS[i]["zoomLevel"] > MAPS[best]['zoomLevel'] && MAPS[i]['zoomLevel'] <= zoom) {
        best = i;
      }
    }
  }
  return MAPS[best];
}
*/

/// fill the content
function fillText(){

  $('#title').append(appendTitle(i18n(4)));
  $('#info-header').html("About");
  $('#info').html(
    "<p class = ''>" + i18n(5) + "</p>" +
    "<p>" + i18n(6) + "</p>" +
    "<h5>" + i18n(7) + "</h5>" +
    "<p>" + i18n(8) + "</p>"
    );
  
  $("#all-maps-header").html(i18n(75));
  let elem = document.getElementById("all-maps");
  for ( let i = 0; i < historicalMaps.length ; i++){
    elem.appendChild(createMapAttributionInline(historicalMaps.get(i)));

  }

}
fillText();

function appendTitle(text){
  const title = document.createElement('span');
  const h2 = document.createElement("h2");
  title.appendChild(h2);
  h2.innerText = text;
  return title
}

/// display map attribution

function createMapAttribution(mapInfoElement){
  return "<small><small>" + mapInfoElement.title + " / " + mapInfoElement.year  +" / " + "<a href='"+mapInfoElement.url+"' target='blank'>" + mapInfoElement.library +"</a></small></small>";

}

function xcreateMapAttribution(mapInfoElement){
  const ul = document.createElement('span');
  ul.className = "";
  
  const title = document.createElement('span');
  title.className = "fw-normal me-2 ms-2 fs-6";
  title.innerText = mapInfoElement.title + "/" + mapInfoElement.year;
  const scale = document.createElement('span');
  scale.className = "fw-light ms-2 fs-6";
  scale.innerText = mapInfoElement.scale;
  const library = document.createElement('span');
  const a = document.createElement('a');
  a.href = mapInfoElement.url;
  a.text = mapInfoElement.library;
  library.className = " ms-2 fs-6";
  library.appendChild(a);
  ul.appendChild(title);
  ul.appendChild(scale);
  ul.appendChild(library);
  return ul
}

function createMapAttributionInline(mapInfoElement){
  const ul = document.createElement('ul');
  ul.className = "list-unstyled";
  
  const title = document.createElement('li');
  title.className = "fw-normal me-2 ms-2 fs-6";
  title.innerText = mapInfoElement.title + "/" + mapInfoElement.year;
  const scale = document.createElement('li');
  scale.className = "fw-light ms-2 fs-6";
  scale.innerText = mapInfoElement.scale;
  const library = document.createElement('li');
  const a = document.createElement('a');
  a.href = mapInfoElement.url;
  a.text = mapInfoElement.library;
  library.className = " ms-2 fs-6";
  library.appendChild(a);
  ul.appendChild(title);
  ul.appendChild(scale);
  ul.appendChild(library);
  return ul;
}

function StyleFunction(feature, resolution) {

  const scale = 3 / (Math.sqrt(Math.sqrt(resolution)));
  let color_value = 'rgba(255, 0, 0, 0.9)';
  let image_src = "";
  let fa_char = "\uf3c5";
  
  if (feature.get('instance') == WD_COLONY) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/colony.svg";
    color_value = 'rgba(0,255, 0, 0.9)';
    fa_char = "\uf111";
  };
  if (feature.get('instance') == WD_MISSION) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/mission.svg";
    color_value = 'rgba(0,0, 255, 0.9)';
    fa_char = "\uf51d";
  };
  if (feature.get('instance') == WD_ENTERPRISE) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/business.svg";
    color_value = 'rgba(255,255,0, 0.9)';
    fa_char ="\uf275";
  };
  if (feature.get('instance') == WD_EDUCATION) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/education.svg";
    color_value = 'rgba(255,255,0, 0.9)';
    fa_char ="\ue53d";
  };
  if (feature.get('instance') == WD_AUTHORITY) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/authority.svg";
    color_value = 'rgba(255,255,0, 0.9)';
    fa_char = "\uf024";
  };
  if (feature.get('instance') == WD_MILITARY) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/flag.svg";
    color_value = 'rgba(255,255,0, 0.9)';
    fa_char = "\ue54b";
  };
  if (feature.get('instance') == WD_EVENT) {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/event.svg";
    color_value = 'rgba(255,255,0, 0.9)';
    fa_char = "\uf0e7";
  };
  if (image_src == "") {
    image_src = "/plugins/arPotsdamPlugin/images/map_icons/general.svg";
    color_value = 'rgba(255,255,0, 0.9)';
  };
  /*if (image_src != "") {
    image = new Icon({
      scale: scale,
      src: image_src
    })
  }*/
 
  return new Style({
    text: new Text({
      font: 'normal 18px FontAwesome',
      text: fa_char,
      textAlign: 'left',
      textBaseline: 'top',
      fill: new Fill({
        color: '#000'
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2
      })
    })
  });
}

const element = document.getElementById('popup');

const popup = new Overlay({
  element: element,
  positioning: 'bottom-center',
  stopEvent: false,
});
map.addOverlay(popup);

let popover;
function disposePopover() {
  if (popover) {
    popover.dispose();
    popover = undefined;
  }
}

function popoverContent(feature){
  let returnString = "";
  returnString = "<span class='fw-bold'>"+feature.get('name') + "</span>";
  if (wdClasses[feature.get('instance')]){
    returnString += "<br><span class='fw-light'>"+wdClasses[feature.get('instance')] + "</span>";
  }
  returnString += "<a class='nav-link text-primary' target = '_blank' href='https://www.wikidata.org/wiki/"+feature.get('id') + "'>" + feature.get('id') +  "</a>";
  return  returnString;
}


map.on('click', function (evt) {
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  });

  disposePopover();
  if (!feature) {
    return;
  }
  if (!feature.values_.hasOwnProperty('id')){
    return;
  };
  popup.setPosition(evt.coordinate);
  popover = new bootstrap.Popover(element, {
    placement: 'top',
    html: true,
    content: popoverContent(feature),
  });
  popover.show();
});


$(function() {
  function log( message ) {
    $( "<div>" ).text( message ).prependTo( "#log" );
    $( "#log" ).scrollTop( 0 );
  }

  $( "#search-input-box" ).autocomplete({
    source: function( request, response ) {
      $.ajax({
        url: "https://ts.archivfuehrer-kolonialzeit.de/search_places_simple.php",
        dataType: "json",
        data: {
          term: request.term
        },
        success: function( data ) {
          console.log(data);
          response( $.map(data, function(item){
            return {
              label: item.name,
              type: item.type,
              value: item.name,
              source: item.source,
              lat:item.lat,
              lon:item.lon,
              err:item.err
            }
          }

          ));
        }
      });
    },
    minLength: 2,
    select: function( event, ui ) {
      $( "#search-input-box" ).attr("data", JSON.stringify(ui.item.value) );
      $( "#search-input-box" ).attr( "term" , ui.item.label );
      $( "#search-input-box" ).val( ui.item.value );
      $("#a-search-documents").attr("href", "https://archivfuehrer-kolonialzeit.de/index.php/informationobject/browse?topLod=0&query=" + jQuery('#search-input-box').attr("term").toLowerCase());
      $("#search-documents").attr("title", "Search for documents related to '" + ui.item.label + "'")
      showPlace(ui.item);
      return false;
    },
    focus: function( event, ui ) {
      $( "#search-box-input" ).val( ui.item.label );
      return false;
    },
    open: function() {
      $( this ).removeClass( "ui-corner-all" ).addClass( "ui-corner-top" );
    },
    close: function() {
      $( this ).removeClass( "ui-corner-top" ).addClass( "ui-corner-all" );
    }
  })      
  .autocomplete( "instance" )._renderItem = function( ul, item ) {
    return $( "<li>" )
      .append( "<div class='border-bottom text-wrap' style='width: 18rem;'> <span class='text-primary'>" + item.label + "</span> <br>" + item.type + "</div>" )
      .appendTo( ul );
  };
});




/*
$( function() {
  console.log("hit");
  $( "#search-box-input" ).autocomplete({
      minLength: 2,
      source: function( request, response ) {
        // Fetch data
        $.ajax({
             url: "https://ts.archivfuehrer-kolonialzeit.de/search_places_simple.php",
             type: 'get',
             dataType: "json",
             data: {
                  term: request.term
             },
             success: function( data ) {
                  response( data );
             }
        });
      },



      focus: function( event, ui ) {
        
        $( "#search-box-input" ).val( ui.item.label );
        return false;
      },
      select: function( event, ui ) {
        $( "#search-box-input" ).attr("data", JSON.stringify(ui.item.value) );
        $( "#search-box-input" ).attr( "term" , ui.item.label );
        $( "#search-box-input" ).val( ui.item.label );
        $("#a-search-documents").attr("href", "https://archivfuehrer-kolonialzeit.de/index.php/informationobject/browse?topLod=0&query=" + jQuery('#search-box-input').attr("term").toLowerCase());
        $("#search-documents").attr("title", "Search for documents related to '" + ui.item.label + "'")
        showPlace(ui.item);
        return false;
      }
    })
    .data("ui-autocomplete")._renderItem = function( ul, item ) {
    /*.data("ui-autocomplete")._renderItem = function( ul, item ) {
      return $( "<li></li>" )
        .data( "item.autocomplete", item )
        .append( "<a>" + item.label + "<br>" + item.value + "</a>" )
        .appendTo( ul );*//*
        let className = "";
        let subTitle = "";
        let featureCodeClass = "";
      if (item.value.map == "geonames") {
        subTitle = item.value.country + " (" + item.value.feature_code + ")";
        featureCodeClass = "ms-1  me-2  fa fa-location-dot text-primary";
        className = "bg-white";
      }
      else {
        subTitle = "Map: "+ item.value.map;
        featureCodeClass = "fa fa-border-top-left ms-1 me-2 text-primary";
        className = "bg-primary";
      }
      let element = $("<li></li>")
        .data( "item.autocomplete", item )
        .append( "<i class='"+featureCodeClass+"'></i><span class='fw-bold me-1'>" + item.label + "</span><br /><i class = 'ms-4 me-1'>" + subTitle + "</i>" )
        .appendTo(ul);
      element.className = className;
      return element;
    };
  });
*/
  /// center map ans render location of seleted place

  function showPlace(location){
    console.log(location);

    let loc = [];
    loc["label"] =  location.value;
    loc["value"] = [];
    loc["value"]["map"] = location.source;
    loc["value"]["lat"] = location.lat;
    loc["value"]["lon"] = location.lon;
    loc["value"]["error"] = location.err;
    console.log(loc);
    goToPlace(loc);
  }

  function RectangleStyle (){
    return new Style({
    stroke: new Stroke({
      color: '#ff0000',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255,255,255,0.01)'
    })
    })
  }


  function locationDotStyle (){
    return new Style({
      text: new Text({
      font: 'normal 18px FontAwesome',
      text: '\uf3c5',
      textAlign: 'left',
      textBaseline: 'top',
      fill: new Fill({
        color: '#ff0000'
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2
      })
    })
  });
  }


  function setLocationMark(lon, lat, error, zoom, style) {
    map.removeLayer(markerVector);

    // this is necessary to draw a point as an very small rectangle
    if (error == 0) {
      error = 0.1;
    }
    //Holds the Polygon feature  
    let polyFeature = new Feature({
      geometry: new Polygon([
        [
          [lon + error, lat - error],
          [lon + error, lat + error],
          [lon - error, lat + error],
          [lon - error, lat - error],
          [lon + error, lat - error]
        ]
      ])
    });
    polyFeature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
    //Holds the Point feature
    let pointFeature = new Feature({
      geometry: new Point(
        [lon, lat])
    });
    pointFeature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
    //A vector layer to hold the features
    markerVector = new VectorLayer({
      source: new VectorSource({
        features: [
          polyFeature,
          pointFeature
        ]
      }),
      style: style
    });
    map.addLayer(markerVector);
  }



  function goToPlace(location) {
   console.log(location);
    if (location.label == "") {
      return;
    }
    let zoom = 0;
    if ( location.value.map =="geonames" ) {
      zoom = 8;
    }
    else {
      zoom = historicalMaps.getMapZoomByCode(location.value.map);
    }
    
    map.getView().setZoom(zoom);
    let lon = parseFloat(location.value.lon.replace(/,/,'.'));
    let lat = parseFloat(location.value.lat.replace(/,/,'.'));
    let error = parseFloat(location.value.error.replace(/,/,'.'));
    let style = new Style;
    map.getView().setCenter(fromLonLat([lon, lat]));
    
    if (location.value.map == "geonames") {
      style = locationDotStyle();
    }
    else {
      style = RectangleStyle();
    }
    setLocationMark(lon,lat,error, zoom, style);
  }

/*
  function getMapZoom(mapCode) {
    let zoom = 8;
    for (var i = 1; i < MAPS.length; i++) {
      if ("code" in MAPS[i]) {
        if (MAPS[i]['code'] == mapCode) {
          zoom = MAPS[i]['zoomLevel'];
          return zoom;
        }
      }
    }
    return zoom;
  }
  */